import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sourcesDate',
    standalone: false
})
export class SourcesDatePipe implements PipeTransform {

  transform(value: any): string {
    if (value) {
      const str = `${value}`;
      if (str.length == 8) {
        return `${str.substring(6)}/${str.substring(4, 6)}/${str.substring(0, 4)}`;
      }
      return value;
    }
    return '-';
  }

}
